import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography, Box, Paper } from "@mui/material";
import { ReactComponent as DTVLogo } from "@/assets/DTV Logo.svg";
import { useCart, useDealer } from "@/contexts";

const TransactionComplete: React.FC = () => {
  const navigate = useNavigate();
  const { dealer, setNewSession } = useDealer();
  const { cart, clear } = useCart();
  console.log(dealer);
  const email = dealer?.email || "jonathan@directvdealer.com";

  const handleDoneClick = () => {
    clear?.();
    setNewSession();
    navigate("/login");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        bgcolor: "#F5F6FA",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: 4,
          width: "97%",
          height: "95%",
          //   maxWidth: 500,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 16px 0 rgba(0,0,0,0.04)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            mb: 8,
          }}
        >
          <DTVLogo
            style={{ width: "500px", height: "auto", display: "block" }}
          />
        </Box>
        <Typography
          component="h1"
          sx={{
            fontSize: 72,
            fontWeight: 500,
            color: "#2D3843",
            fontFamily: "PF DIN Text Pro",
          }}
        >
          Transaction complete!
        </Typography>
        <Typography
          sx={{
            color: "#2D3843",
            mb: 5,
            fontSize: 20,
            fontFamily: "PF DIN Text Pro",
          }}
        >
          Order Number <b>#{cart?.orderId}</b> | Receipt emailed to <b>{email}</b>
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{
            borderRadius: 2,
            px: 5,
            py: 1.5,
            fontWeight: 500,
            fontSize: '22px',
            textTransform: "none",
            fontFamily: "PF DIN Text Pro",
          }}
          onClick={handleDoneClick}
        >
          Done
        </Button>
      </Paper>
    </Box>
  );
};

export default TransactionComplete;
